import { render, staticRenderFns } from "./PersonalConsiderations.vue?vue&type=template&id=200f199f&scoped=true"
import script from "./PersonalConsiderations.vue?vue&type=script&lang=ts"
export * from "./PersonalConsiderations.vue?vue&type=script&lang=ts"
import style0 from "./PersonalConsiderations.vue?vue&type=style&index=0&id=200f199f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f199f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200f199f')) {
      api.createRecord('200f199f', component.options)
    } else {
      api.reload('200f199f', component.options)
    }
    module.hot.accept("./PersonalConsiderations.vue?vue&type=template&id=200f199f&scoped=true", function () {
      api.rerender('200f199f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/PersonalConsiderations.vue"
export default component.exports